import { CurrencyConverter } from "@/lib/constants";
import { ButtonBase, Radio, Stack, Typography } from "@mui/material";

export default function EmiOption({ label, amount, selected = true, onClick }) {
  return (
    <ButtonBase
      onClick={onClick}
      sx={{
        width: "100%",
        paddingX: "12px",
        paddingY: "8px",
        bgcolor: "background.paper",
      }}
    >
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        sx={{ width: "100%" }}
      >
        <Stack direction="row" alignItems="center" gap={1}>
          <Radio
            checked={selected}
            color="success"
            disableRipple
            sx={{
              p: 0.25,
              "& .MuiSvgIcon-root": { fontSize: 18 },
            }}
            inputProps={{ "aria-label": label }}
          />
          <Typography
            fontWeight={400}
            fontSize={{ xs: "14px", md: "16px" }}
            color="#0D0D0D"
          >
            {label}
          </Typography>
        </Stack>

        <Typography
          fontWeight={500}
          fontSize={{ xs: "14px", md: "16px" }}
          color="#0D0D0D"
        >
          {CurrencyConverter(amount ?? 0)}
        </Typography>
      </Stack>
    </ButtonBase>
  );
}
